export default "__VITE_ASSET__DKvWFcBh__"